module.exports = __webpack_public_path__ + "system/img/personal-icon-03.3c13057d.png";